import { AppConstants } from '../../constants/AppConstants';
import { uniq, flatten, find, isEmpty, isArray } from 'lodash';
import { hasNumberGreaterThenZero } from '../../util/validators';
import { urlPATTERN } from '../../util/constants';

const getIntegerValidation = (validator: any, value: any, label: any, t: any) => {
  let errorLabel: any = false;
  const { max = '', min } = validator;

  if (max && value > max) {
    errorLabel = `${t('T_VALIDATION_SETTINGS_INTEGER_MAX')
      .replace('${LABEL}', t(label))
      .replace('${MAX}', max)}`;
  } else if (min >= 0 && value < min) {
    errorLabel = `${t('T_VALIDATION_SETTINGS_INTEGER_MIN')
      .replace('${LABEL}', t(label))
      .replace('${MIN}', min)}`;
  }
  return errorLabel;
};

const getURIValidation = (validator: any, value: any, label: any, t: any) => {
  let errorLabel: any = false;
  const errorIdx: any = {};

  if (isArray(value)) {
    const redirectUrls = value.forEach((url: any, index: any) => {
      if (!urlPATTERN.test(url)) {
        errorLabel = `${t('T_SECURITY_SETTINGS_URL_VALIDATION')}`;
        errorIdx[index] = errorLabel;
      }
    });
  }
  console.log(errorIdx);
  return !isEmpty(errorIdx) ? errorIdx : errorLabel;
};

export const handleSettingsValidation = (formData: any, fieldSchema: any, t: any) => {
  let formError: any = {};
  fieldSchema.forEach((obj: any) => {
    const { validators, key, label } = obj;
    if (validators && validators.length) {
      validators.forEach((validator: any) => {
        switch (validator.type) {
          case 'integer':
            formError[key] = getIntegerValidation(validator, formData[key], label, t);
            break;
          case 'uri':
            formError[key] = getURIValidation(validator, formData[key], label, t);
            break;
        }
      });
    }
  });

  return formError;
};

export const validateSettingsSave = (formData: any, fieldSchema: any) => {
  let isDisabled = false;
  fieldSchema.forEach((obj: any) => {
    const { validators, key, label } = obj;
    if (obj.required && formData[key].toString().trim() === '') {
      isDisabled = true;
    }
  });
  return isDisabled;
};
